export function SET_B64_IMAGE(state, data) {
  state.imageUrlB64 = data;
}
